import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

class RangeValueItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDescriptionOpenOnMobile: false,
        };

        this.toggleDescription = this.toggleDescription.bind(this);
    }

    toggleDescription() {
        this.setState((oldState) => {
            return {
                isDescriptionOpenOnMobile: !oldState.isDescriptionOpenOnMobile,
            };
        });
    }

    render() {
        const { backgroundColor, classesName, description, value, title, dataTest } = this.props;
        const classesString = classesName.join(' ');
        const boxStyle = {
            backgroundColor,
        };
        return (
            <div className={`range-value_column ${classesString}`} style={boxStyle}>
                <div className="range-value_column_main-content">
                    <h2 className="sr-text is-uppercase is-small range-value_column_main-content_title">{title}</h2>
                    <div className="sr-title-2 is-bold range-value_column_main-content_value" data-test={dataTest}>
                        {value > 0
                            ? LocaleService.l(value, CurrencyFormats.CURRENCY_0)
                            : LocaleService.t('TRADE_IN.NON_AVAILABLE')}
                    </div>
                    <div className="arrow">
                        <icon className="icon-arrow-circle" />
                    </div>
                    <div className="description-toggle">
                        <button className="sr-text sr-link" onClick={this.toggleDescription}>
                            {LocaleService.t('TRADE_IN.ESTIMATE.WHAT_IT_MEANS')}
                        </button>
                    </div>
                </div>

                <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                    <div className="range-value_column_description is-small">{description}</div>
                </MediaQuery>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <div className="range-value_column_description_wrapper">
                        <ReactCSSTransitionGroup transitionName="description">
                            {this.state.isDescriptionOpenOnMobile && (
                                <div className="range-value_column_description is-small">{description}</div>
                            )}
                        </ReactCSSTransitionGroup>
                    </div>
                </MediaQuery>
            </div>
        );
    }
}

RangeValueItem.defaultProps = {
    classesName: [],
    dataTest: '',
};

RangeValueItem.displayName = 'RangeValueItem';

RangeValueItem.propTypes = {
    backgroundColor: PropTypes.string.isRequired,
    classesName: PropTypes.shape([PropTypes.string.isRequired]),
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    dataTest: PropTypes.string,
};

export default RangeValueItem;



// WEBPACK FOOTER //
// ./src/components/CanadianBlackBookEstimate/components/RangeValueItem.jsx